'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip, Skeleton } from '@common/components';
interface FilterChipGroupProps<T extends string | number> {
  options: {
    value: T;
    label: string;
  }[];
  selectedValues: T[];
  onToggle: (value: T) => void;
  isLoading?: boolean;
  skeletonCount?: number;
}
const SKELETON_CHIP_WIDTHS = [60, 80, 72, 92, 64];
export function FilterChipGroup(t0) {
  const $ = _c(11);
  const {
    options,
    selectedValues,
    onToggle,
    isLoading: t1,
    skeletonCount: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const skeletonCount = t2 === undefined ? 5 : t2;
  if (isLoading) {
    let t3;
    if ($[0] !== skeletonCount) {
      t3 = <div className="flex flex-wrap gap-8">{Array.from({
          length: skeletonCount
        }, _temp)}</div>;
      $[0] = skeletonCount;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  if (options.length < 1) {
    return null;
  }
  let t3;
  if ($[2] !== onToggle || $[3] !== options || $[4] !== selectedValues) {
    let t4;
    if ($[6] !== onToggle || $[7] !== selectedValues) {
      t4 = option => <Chip key={String(option.value)} checked={selectedValues.includes(option.value)} onCheckedChange={() => onToggle(option.value)} theme="primary-line" className="px-16 py-8 typo-body4">{option.label}</Chip>;
      $[6] = onToggle;
      $[7] = selectedValues;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = options.map(t4);
    $[2] = onToggle;
    $[3] = options;
    $[4] = selectedValues;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="flex flex-wrap gap-8">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(_, index) {
  return <Skeleton key={index} className="h-39 rounded-pill" style={{
    width: `${SKELETON_CHIP_WIDTHS[index % SKELETON_CHIP_WIDTHS.length]}px`
  }} />;
}